/* rb-m-pages.js -- secondary pages. Phone only, needs window.RBM. */
(function () {
  'use strict';
  if (!window.RBM) return;

  /* ---- size guide: one row per brand ------------------------------------------
     /pages/size-guide renders every brand's charts expanded: 43 .rsg__brand
     sections of 1,500-3,200px each, 82,084px in all (measured 15 Sep). The
     page already has the right tools -- a brand search, category chips, a
     jump-to-brand <select> and a rail of #anchor links -- so on a phone each
     brand collapses to its 48px heading and opens on tap, on the select, on a
     rail link, or when the page is entered with a #brand hash (which is what
     every PDP's "size chart" link does). rb-m-pages.css does the hiding;
     this only manages .is-open. Desktop is untouched. */
  RBM.onMobile('pages-sizeguide', function () {
    var main = document.querySelector('.rsg__main');
    if (!main || main.dataset.rbm) return;
    main.dataset.rbm = '1';
    var brands = main.querySelectorAll('.rsg__brand');
    if (brands.length < 6) return;                 /* a short page can stay open */

    function open(sec, scroll) {
      if (!sec) return;
      sec.classList.add('is-open');
      var h = sec.querySelector('.rsg__brand-name');
      if (h) h.setAttribute('aria-expanded', 'true');
      if (scroll) setTimeout(function () { sec.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 30);
    }
    function toggle(sec) {
      var on = sec.classList.toggle('is-open');
      var h = sec.querySelector('.rsg__brand-name');
      if (h) h.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function byHash(hash) {
      var id = (hash || '').replace(/^#/, '');
      if (!id) return null;
      var el = document.getElementById(id);
      return el && el.classList.contains('rsg__brand') ? el : null;
    }

    Array.prototype.forEach.call(brands, function (sec) {
      sec.classList.add('rbm-sg');
      var h = sec.querySelector('.rsg__brand-name');
      if (!h) return;
      h.setAttribute('role', 'button');
      h.setAttribute('tabindex', '0');
      h.setAttribute('aria-expanded', 'false');
      h.addEventListener('click', function () { toggle(sec); });
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(sec); }
      });
    });

    /* Entry with a hash (PDP size-chart links), rail anchors, and the jump
       select all resolve to a brand id. */
    open(byHash(location.hash), true);
    window.addEventListener('hashchange', function () { open(byHash(location.hash), true); });
    var jump = document.querySelector('[data-rsg-jump]');
    if (jump) jump.addEventListener('change', function () {
      open(byHash(jump.value) || document.getElementById(jump.value), true);
    });
    /* A search that leaves a single brand showing may as well open it. */
    var q = document.querySelector('[data-rsg-q]');
    if (q) q.addEventListener('input', RBM.debounce(function () {
      var shown = Array.prototype.filter.call(brands, function (s) { return s.offsetParent !== null; });
      if (shown.length === 1) open(shown[0], false);
    }, 200));
  });
})();
